import {
  thickness,
  length,
  width,
  certification
} from '@/modules/standardItems/schemas/baseFormFields'

export function moistureResistant ({
  classes = ['xs12', 'sm4', 'input__wrapper', 'input__wrapper--centered'],
  inputClasses = ['input--dense']
} = {}) {
  return {
    key: 'moistureResistant',
    value: 'moistureResistant',
    type: 'checkbox',
    classes,
    attributes: {
      label: 'Moisture Resistant',
      class: inputClasses
    }
  }
}

export function fireRated ({
  classes = ['xs12', 'sm4', 'input__wrapper', 'input__wrapper--centered'],
  inputClasses = ['input--dense']
} = {}) {
  return {
    key: 'fireRated',
    value: 'fireRated',
    type: 'checkbox',
    classes,
    attributes: {
      label: 'Fire Rated',
      class: inputClasses
    }
  }
}

export function manufacturers () {
  return {
    key: 'manufacturers',
    value: 'manufacturers',
    attributes: {
      class: 'sub-form'
    }
  }
}

export function sheetStockFormFields () {
  return [
    thickness({ classes: ['xs12', 'sm4', 'input--short'], autofocus: true }),
    width({ classes: ['xs12', 'sm4', 'input--short'] }),
    length({ classes: ['xs12', 'sm4', 'input--short'] }),
    certification()
  ]
}

export default sheetStockFormFields
